import { render, staticRenderFns } from "./k-bread-crumb.vue?vue&type=template&id=18ebca03&scoped=true&"
import script from "./k-bread-crumb.vue?vue&type=script&lang=ts&"
export * from "./k-bread-crumb.vue?vue&type=script&lang=ts&"
import style0 from "./k-bread-crumb.vue?vue&type=style&index=0&id=18ebca03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ebca03",
  null
  
)

export default component.exports